var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.77428 9.20377C5.99733 10.4268 7.98029 10.4268 9.20334 9.20377C10.4264 7.98072 10.4264 5.99776 9.20334 4.77471C7.98029 3.55166 5.99733 3.55166 4.77428 4.77471C3.55123 5.99776 3.55123 7.98072 4.77428 9.20377Z",
    fill: "url(#paint0_linear_3876_11934)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7964 19.2258C16.0194 20.4489 18.0024 20.4489 19.2254 19.2258C20.4485 18.0028 20.4485 16.0198 19.2254 14.7968C18.0024 13.5737 16.0194 13.5737 14.7964 14.7968C13.5733 16.0198 13.5733 18.0028 14.7964 19.2258Z",
    fill: "url(#paint1_linear_3876_11934)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7959 9.20377C16.0189 10.4268 18.0019 10.4268 19.2249 9.20377C20.448 7.98072 20.448 5.99776 19.2249 4.77471C18.0019 3.55166 16.0189 3.55166 14.7959 4.77471C13.5728 5.99776 13.5728 7.98072 14.7959 9.20377Z",
    fill: "url(#paint2_linear_3876_11934)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.77511 19.2255C5.99816 20.4486 7.98112 20.4486 9.20417 19.2255C10.4272 18.0025 10.4272 16.0195 9.20417 14.7965C7.98112 13.5734 5.99816 13.5734 4.77511 14.7965C3.55206 16.0195 3.55206 18.0025 4.77511 19.2255Z",
    fill: "url(#paint3_linear_3876_11934)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.77428 9.20377C5.99733 10.4268 7.98029 10.4268 9.20334 9.20377C10.4264 7.98072 10.4264 5.99776 9.20334 4.77471C7.98029 3.55166 5.99733 3.55166 4.77428 4.77471C3.55123 5.99776 3.55123 7.98072 4.77428 9.20377Z",
    stroke: "url(#paint4_linear_3876_11934)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7964 19.2258C16.0194 20.4489 18.0024 20.4489 19.2254 19.2258C20.4485 18.0028 20.4485 16.0198 19.2254 14.7968C18.0024 13.5737 16.0194 13.5737 14.7964 14.7968C13.5733 16.0198 13.5733 18.0028 14.7964 19.2258Z",
    stroke: "url(#paint5_linear_3876_11934)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7959 9.20377C16.0189 10.4268 18.0019 10.4268 19.2249 9.20377C20.448 7.98072 20.448 5.99776 19.2249 4.77471C18.0019 3.55166 16.0189 3.55166 14.7959 4.77471C13.5728 5.99776 13.5728 7.98072 14.7959 9.20377Z",
    stroke: "url(#paint6_linear_3876_11934)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.77511 19.2255C5.99816 20.4486 7.98112 20.4486 9.20417 19.2255C10.4272 18.0025 10.4272 16.0195 9.20417 14.7965C7.98112 13.5734 5.99816 13.5734 4.77511 14.7965C3.55206 16.0195 3.55206 18.0025 4.77511 19.2255Z",
    stroke: "url(#paint7_linear_3876_11934)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3876_11934",
    x1: 11.9999,
    y1: 3.5501,
    x2: 11.6368,
    y2: 20.6172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1851B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#99AFD3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3876_11934",
    x1: 11.9999,
    y1: 3.5501,
    x2: 11.6368,
    y2: 20.6172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1851B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#99AFD3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3876_11934",
    x1: 11.9999,
    y1: 3.5501,
    x2: 11.6368,
    y2: 20.6172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1851B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#99AFD3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3876_11934",
    x1: 11.9999,
    y1: 3.5501,
    x2: 11.6368,
    y2: 20.6172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1851B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#99AFD3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3876_11934",
    x1: 11.9999,
    y1: 3.85742,
    x2: 11.9999,
    y2: 20.1431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E3C81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95ACD2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3876_11934",
    x1: 11.9999,
    y1: 3.85742,
    x2: 11.9999,
    y2: 20.1431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E3C81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95ACD2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3876_11934",
    x1: 11.9999,
    y1: 3.85742,
    x2: 11.9999,
    y2: 20.1431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E3C81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95ACD2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3876_11934",
    x1: 11.9999,
    y1: 3.85742,
    x2: 11.9999,
    y2: 20.1431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E3C81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95ACD2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardFill);
export default __webpack_public_path__ + "static/media/DashboardFill.91154cf5358250725c2b8ffe7583d089.svg";
export { ForwardRef as ReactComponent };